import {loading, stopLoading} from "../../helpers/loading";
import {handleAjaxSuccess} from "../../helpers/swalHelper";
import handleAjaxError from "../../helpers/handleAjaxError";
import {initClientAccountForm} from "./form";

function initClientAccountsCreate() {
	const accountForm = initClientAccountForm(document.querySelector('.client-account-form'));

	document.querySelector('.create-new-account-button').onclick = createNewAccount;

	/** Methods */

	function createNewAccount() {
		accountForm.clearFeedbacks();

		loading();

		accountForm.submit()
			.then(handleAjaxSuccess)
			.catch(handleAjaxError)
			.finally(stopLoading);
	}
}

export {initClientAccountsCreate}
